import React from 'react';
import PropTypes from 'prop-types';

import LightBulb from '../../../../common/img/components/LightBulb';

import styles from './EventListingsQuickTips.module.scss';

const EventListingsQuickTips = ({ tips, topMargin = false }) => {
  const tipBullets = tips.map((tip) => {
    return (
      <div key={tip.key} className={styles.bullet}>
        <LightBulb className={styles.lightbulb} />
        <span className={styles.text}>{tip.text}</span>
      </div>
    );
  });

  let styleClasses = `${styles.container}`;
  if (topMargin) styleClasses += ` ${styles['container--top-margin']}`;
  return (
    <aside className={styleClasses}>
      {tipBullets}
    </aside>
  );
};

EventListingsQuickTips.propTypes = {
  tips: PropTypes.arrayOf(PropTypes.object).isRequired,
  topMargin: PropTypes.bool,
};

export default EventListingsQuickTips;
